var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntershiptype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77778 1.77778L29 1.77899M8.77778 11.1111L29 11.1124M8.77778 20.4444L29 20.4455M1 2.55556H2.55556V1H1V2.55556ZM1 11.8889H2.55556V10.3333H1V11.8889ZM1 21.2222H2.55556V19.6667H1V21.2222Z",
    stroke: "#BCBCBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntershiptype);
export default __webpack_public_path__ + "static/media/intershiptype.66d9b63dadb2da89b19d5c1ee6108030.svg";
export { ForwardRef as ReactComponent };